import API from '../Services/API';
import Model from './Model';
import { toQueryString, buildPowerSearchCacheKey, buildPowerSearchRequest, hasPowerSearchCriteria } from './powerSearchHelpers';

const useOnboardingJourney = (alwaysRefresh, block = false) => {
    return Model({
        block,
        alwaysRefresh,
        returnDataKey: 'journey',
        stateKey: 'onboarding',
        fetchData: () => API.get('/onboarding/journey'),
        registerAdditionalMethods: (opts) => {
            return {
                markStepDone: (stepKey) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/steps/${stepKey}/done/`),
                        null,
                        true,
                    );
                },
                markStepSkipped: (stepKey) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/steps/${stepKey}/skip/`),
                        null,
                        true,
                    );
                },
                markVideoAsPlayed: (videoId) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/videos/${videoId}/played`),
                        null,
                        true,
                    );
                },
                markVideoAsUnplayed: (videoId) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/onboarding/videos/${videoId}/unplayed`),
                        null,
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading the onboarding journey.',
    });
}

const useShipments = (searchData, alwaysRefresh) => {
    const searchStr = toQueryString(searchData || {});
    const cacheKey = buildPowerSearchCacheKey(searchData, searchStr);

    return Model({
        alwaysRefresh,
        stateKey: ['shipments', cacheKey],
        fetchData: () => {
            if (hasPowerSearchCriteria(searchData)) {
                return API.post('/admin/shipments/search', buildPowerSearchRequest(searchData));
            }

            return API.get('/admin/shipments?' + searchStr);
        },
        returnDataKey: 'shipments',
        defaultLoadingError: 'Failed to load shipments.',
        registerAdditionalMethods: (opts) => {
            return {
                sendItemCommand: (shipmentId, command) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/admin/shipments/${shipmentId}/command`, command),
                        null,
                        true,
                    );
                }
            }
        },
    });
}

const itemCommands = [
    {
        commandType: 'RedraftItemCommand',
        label: 'Redraft Message',
        icon: 'Pencil',
        validForTypes: ['InsulatedBottle'],
    },
    {
        commandType: 'MarkAsPostedItemCommand',
        label: 'Mark as Posted',
        icon: 'Check',
        validForTypes: ['InsulatedBottle'],
    },
];

const shipmentStatusMap = {
    'Planned': {
        name: 'Planned',
        icon: 'Circle',
        theme: 'secondary',
    },
    'Prepared': {
        name: 'Prepared',
        icon: 'Clock',
        theme: 'info',
    },
    'Sent': {
        name: 'Sent',
        icon: 'CircleArrowRight',
        theme: 'success',
    },
    'Received': {
        name: 'Received',
        icon: 'CircleCheck',
        theme: 'success',
    },
};

const shipmentTypeMap = {
    'Example': 'Example',
    'MockItem': 'Mock Item',
    'WelcomeCard': 'Welcome Card',
    'InsulatedBottle': 'Insulated Bottle',
};

export {
    useOnboardingJourney,
    useShipments,
    shipmentStatusMap,
    shipmentTypeMap,
    itemCommands,
}
